import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import ConfigureDevice from '../../../../components/rooms/ConfigureDevice'
import Page404 from '../../../../routes/404'

import { rooms as ROLES_CONFIG } from '../../../../config/roles';


export default class DeviceConfigure extends Component {

	constructor(props) {
		super(props);
		this.state = {
			role: this.props.authenticated ? this.props.authenticated.role : null,
			_id: this.props && this.props.match && this.props.match.params ? this.props.match.params.id : ''
		}
	}

	render() {
		return (
			<div id="content">
				<div className="row">
					{
						ROLES_CONFIG.configureDevices.indexOf(this.state.role) != -1 ?
							<Paper className="col-md-11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
								{
									this.state._id && this.state._id.split('_')[0] && this.state._id.split('_')[1] && this.state._id.split('_')[2] && this.state._id.split('_')[3] ? <ConfigureDevice room_id={this.state._id.split('_')[0]} UDid={this.state._id.split('_')[1]} kd_id={this.state._id.split('_')[2]} mqttPassword={this.state._id.split('_')[3]} /> : <Page404 />
								}
							</Paper> 
						: null
					}
				</div>
			</div>
		)
	}
} 


// WEBPACK FOOTER //
// ./routes/app/routes/rooms/DeviceConfigure.js